var map = {
	"./instagram-hover.svg": 5217,
	"./mail-hover.svg": 7371,
	"./telegram-hover.svg": 4787,
	"./vk-hover.svg": 9474,
	"./yandex-music-hover.svg": 1631,
	"./youtube-hover.svg": 8051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4889;